// src/services/instances/match_v2.ts
//
// Cliente HTTP para Matches do serviço competitions.

import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';

import {
  GetMatchesV2Response,
  GetMatchV2ByIdResponse,
  PostMatchV2Response,
  PutMatchV2Response,
  PostMatchesGenerateResponse,
} from '../response/match_v2';

import {
  PostMatchV2Request,
  PutMatchV2Request,
  PostMatchesGenerateRequest,
} from '../request/match_v2';

export class MatchV2Service {
  /** GET /matches — lista paginada. */
  static getMatches(params?: QueryParams) {
    return apiClient.get<GetMatchesV2Response>(buildApiUrl('/api/v1/competitions/matches'), params);
  }

  /** GET /matches/:id — detalhe. */
  static getMatchById(id: string) {
    return apiClient.get<GetMatchV2ByIdResponse>(buildApiUrl('/api/v1/competitions/matches/:id', { id }));
  }

  /** POST /matches — cria (idempotente). */
  static postMatch(data: PostMatchV2Request) {
    return apiClient.post<PostMatchV2Response>(buildApiUrl('/api/v1/competitions/matches'), data);
  }

  /** PUT /matches/:id — atualiza. */
  static putMatch(id: string, data: PutMatchV2Request) {
    return apiClient.update<PutMatchV2Response>(buildApiUrl('/api/v1/competitions/matches/:id', { id }), data);
  }

  /** DELETE /matches/:id — remove. */
  static deleteMatch(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/competitions/matches/:id', { id }));
  }

  /** POST /matches/generate — gera calendário automático. */
  static generateMatches(data: PostMatchesGenerateRequest) {
    return apiClient.post<PostMatchesGenerateResponse>(
      buildApiUrl('/api/v1/competitions/matches/generate'),
      data,
    );
  }
}
